import React, {Component} from 'react';
import Reveal from './Reveal';
import {connectToStore} from './Provider';

class NewReleaseEmailCaptureHero extends Component {
	constructor() {
		super();
		this.state = {email: ''};
	}

	onSubmit = event => {
		event.preventDefault();

		this.props.openNewReleaseHeroModal(this.state.email);
	}

	render() {
		const {
			title,
			subtitle,
		} = this.props;

		const {
			email
		} = this.state;

		return (
			<Reveal>
				<div className="bg--gray-bg pt6 pb6 pt12--md pb12--md bb--gray-border">
					<div className="grid-container contained">
						<div className="row align--center">
							<div className="col c10--md c8--lg mb2 mb4--lg reveal__slide reveal__slide--medium reveal__delay--3">
								<h1 className="tc domaine--large mb2">
									{title}
								</h1>
								<h2 className="show--md color--gray-text tc sans--medium">
									{subtitle}
								</h2>
								<h2 className="hide--md color--gray-text tc">
									{subtitle}
								</h2>
							</div>
							<div className="col c8--md c5--lg reveal__slide reveal__slide--medium reveal__delay--5">
								<form
									onSubmit={this.onSubmit}
									className="pr">
									<input
										value={email}
										onChange={event => this.setState({email: event.target.value})}
										name="email"
										className="full-width input--newsletter-gray"
										placeholder="Enter Your Email Address"
									/>
									<button
										title="Submit"
										className="db input--newsletter__submit"
										type="submit"
										name="submit">
										<img
											className="full-width"
											src="/images/icon-arrow-newsletter.svg"
										/>
									</button>
								</form>
							</div>
						</div>
					</div>
				</div>
			</Reveal>
		);
	}
}

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openNewReleaseHeroModal,
}) => ({
	openNewReleaseHeroModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(NewReleaseEmailCaptureHero);